export default __webpack_public_path__ + "static/media/10_long.fddbaca1.svg";